import React, { useRef, useEffect, FunctionComponent } from "react";

declare global {
  interface Window {
    Trustpilot: any;
  }
}

type TrustpilotProps = {
  dataLocale: string;
  dataTemplateId: string;
  dataBusinessunitId: string;
  dataStyleHeight: string;
  dataStyleWidth: string;
  dataTheme: string;
  dataStars?: string;
  dataReviewLanguages?: string;
};

const TrustBox: FunctionComponent<TrustpilotProps> = ({
  dataLocale,
  dataTemplateId,
  dataBusinessunitId,
  dataStyleHeight,
  dataStyleWidth,
  dataTheme,
}) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = useRef(null);

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.

    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div
    ref={ref}
    className="trustpilot-widget"
    data-locale={dataLocale}
    data-template-id={dataTemplateId}
    data-businessunit-id={dataBusinessunitId}
    data-style-height={dataStyleHeight}
    data-style-width={dataStyleWidth}
    data-theme={dataTheme}
    >
      <a
        href="https://uk.trustpilot.com/review/www.sook.space"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        Trustpilot
      </a>
    </div>
  );
};
export default TrustBox;
